module.exports = __webpack_public_path__ + "static/media/markerLocation.84c26bb9.svg";